<template>
  <div class="check-in-record-modal border-1 border-r-8">
    <r-table
      :dataSource="recordList"
      :options="options"
      :pagination="privatePagination"
      @current-change="handlePageChange"
    >
      <el-table-column
        prop="orderCode"
        label="订单编码"
        width="350"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column
        prop="storeName"
        label="入住门店"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column
        prop="roomTypeName"
        label="入住房型"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column
        prop="roomName"
        label="入住房源"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column
        prop=""
        label="抵离时间"
        show-overflow-tooltip
        width="250"
      >
        <template #default="scope">
          <div class="time-column flex-center" v-if="scope.row.actualCheckInTime && scope.row.actualCheckOutTime">
            <div class="left-content m-r-10">
              <div class="in-time">
                <span class="badge m-r-5">抵</span>
                <span class="time">{{
                  scope.row.actualCheckInTime || "--"
                }}</span>
              </div>
              <div class="out-time">
                <span class="badge m-r-5">离</span>
                <span class="time">{{
                  scope.row.actualCheckOutTime || "--"
                }}</span>
              </div>
            </div>
            <div class="right-time-total">共{{ getTime(scope.row) }}</div>
          </div>
        </template>
      </el-table-column>
      <el-table-column
        prop="orderPrice"
        label="房费"
        show-overflow-tooltip
      ></el-table-column>
    </r-table>
  </div>
  <div class="align-r m-t-20 p-t-10">
    <el-button class="submit-btn" @click="handleCancel">确定</el-button>
    <el-button class="cancel-btn" @click="handleCancel">取消</el-button>
  </div>
</template>

<script>
import RModal from '@/components/common/RModal'
import RTable from '@/components/common/RTable'
import tableMix from '@/components/common/tableListMixin.js'
import { mapActions } from "vuex";
export default {
  components: { RTable, RModal },
  mixins: [tableMix],
  props: ['tenantId'],
  emits: ['close'],
  data() {
    return {
      recordList: [],
      privatePagination: { total: 0, pageIndex: 1, pageSize: 20 }
    }
  },
  computed: {
    getTime() {
      return row => {
        if (!row.actualCheckInTime || !row.actualCheckOutTime) {
          return '--'
        }
        let stayCount = 1;
        let sTime = +(new Date(row.actualCheckInTime))
        let eTime = +(new Date(row.actualCheckOutTime))
        if (row.orderType == 1) {
          stayCount = Math.round((eTime - sTime) / (24 * 60 * 60 * 1000))
        } else {
          stayCount = Math.round((eTime - sTime) / (60 * 60 * 1000))
        }

        stayCount = (stayCount === 0 ? 1 : stayCount)

        return stayCount + (row.orderType == 1 ? '晚' : '时')
      }
    }
  },
  created() {
    this.getQuery();
    this.initOptions();
  },

  methods: {
    ...mapActions(["fetchData"]),

    // 获取租客入住记录
    getQuery() {
      if (!this.tenantId) return;
      let url = 'TENANT.CHECK_IN_RECORD'
      this.fetchData({
        url,
        method: 'get',
        params: { tenantId: this.tenantId, pageSize: this.privatePagination.pageSize, pageNumber: this.privatePagination.pageIndex }
      }).then(res => {
        this.recordList = res?.data || [];
        this.privatePagination.total = res?.rowCount || 0
      })
    },

    // 初始化table options
    initOptions() {
      this.options['maxHeight'] = "400px"
    },

    // 关闭对话框
    handleCancel() {
      this.$emit('close')
    }
  }

}
</script>

<style lang="less" scoped>
.check-in-record-modal .el-table .time-column {
  .left-content {
    .in-time .badge {
      background-color: #52b82f;
    }
    .out-time .badge {
      background-color: #fe4d4d;
    }
  }
}
</style>